import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export default function BasicDialog(props) {
  const { setOpen, children, title, maxWidth, ...rest } = props;
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog maxWidth={maxWidth ?? "xs"} 
        fullWidth {...rest} >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </div>
  );
}
